module.exports = __webpack_public_path__ + "img/speed.f09b4e84.svg";